export default __webpack_public_path__ + "locales/ar-SA/ChangePortalOwner.json?hash=7aea4a38b457c45c55f21f9c4a37daf7";